import React, {useEffect} from "react";
import SelectAllMenuList from "../SelectAllMenuList/SelectAllMenuList";
import {getLinkedAdvertiserList} from "../../utils/util";
import {useApolloClient} from "@apollo/client";

const AccountSelectionDropdown = ({setSelectedAdvertiserFilterList, optionList, setOptionList, clearAll}) => {
    const client = useApolloClient();
    const loadAdvertiserData = async () => {
        setOptionList(await getLinkedAdvertiserList(client));
    };
    useEffect(() => {
        loadAdvertiserData();
    }, []);

    return (
        <SelectAllMenuList id="accountSelector"
                           setSelectedFilterList={setSelectedAdvertiserFilterList}
                           optionList={optionList}
                           clearAll={clearAll}/>
    )
}

export default AccountSelectionDropdown;